import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './HomeIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const HomeIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function HomeIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 20 22" component={Icon} {...props} />
  );
});
